export default (conf) => ({
  id: conf.id,
  field: conf.field,
  options: conf,
  transformer: () => (x) => x,
});
